<template>
  <div>
    <el-card class="box-card">
      <template slot="header">
        <span style="font-size: 14px">角色权限设置</span>
        <el-button
          style="float: right; margin-bottom: 5px"
          type="primary"
          plain
          icon="el-icon-plus"
          @click="add"
          >添加</el-button
        >
      </template>
      <el-form :inline="true" ref="from" :model="params" label-width="auto">
        <el-form-item label="权限名称">
          <el-input v-model="params.keyword"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="search" icon="el-icon-search"
            >搜索</el-button
          >
          <el-button type="text" @click="clean">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-table class="box-table" :data="RoleInfos" border style="width: 100%">
      <el-table-column prop="name" label="权限名称" width="180" />
      <el-table-column prop="create_time" label="添加时间" />
      <el-table-column label="操作">
        <template slot-scope="data">
          <el-button type="text" icon="el-icon-view" @click="view(data.row)">
            查看
          </el-button>
          <el-button type="text" icon="el-icon-edit" @click="edit(data.row)">
            编辑
          </el-button>
          <el-button type="text" icon="el-icon-delete" @click="del(data.row)">
            删除
          </el-button>
          <el-button type="text" icon="el-icon-setting" @click="openUserList(data.row)">
            增加操作员
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="float: right; margin-top: 8px"
      background
      :page-size.sync="pageSize"
      layout="sizes, total, prev, pager, next"
      :total="totalCount"
      :current-page.sync="page"
    />
    <role-detail
      ref="RoleDetail"
      :dialogVisible.sync="viewer.dialogVisible"
      :id="viewer.id"
      :name="viewer.name"
      :mode="viewer.mode"
      @close="closeDetail"
    />

    <role-user-list
      :dialogVisible.sync="userList.dialogVisible"
      :id="userList.id"
      :name="userList.name"
      @close="closeUserList"
    />
  </div>
</template>
<script>
import Http from "@/components/Admin/Flow/common/Http";
import RoleDetail from "@/components/Admin/Config/Role/RoleDetail";
import RoleUserList from "@/components/Admin/Config/Role/RoleUserList";
export default {
  name: "RoleList",
  components: { RoleDetail, RoleUserList },
  data() {
    return {
      page: 1,
      pageSize: 10,
      totalCount: 100,
      viewer: {
        mode: "view",
        dialogVisible: false,
        id: 0,
        name: "",
        permissions: "",
      },
      userList: {
        dialogVisible: false,
        id: 0,
        name: "",
      },
      params: {
        keyword: "",
      },
      RoleInfos: [],
    };
  },
  mounted() {
    this.search();
  },
  watch: {
    page(n) {
      this.search();
    },
    pageSize(n) {
      this.search();
    },
  },
  methods: {
    search() {
      this.params.page = this.page;
      this.params.pageSize = this.pageSize;
      Http.post("flow/role/getLists", this.params, (res) => {
        this.RoleInfos = res.RoleInfos;
        this.page = res.page;
        this.totalCount = res.totalCount;
        this.pageSize = res.pageSize;
      });
    },
    clean() {
      this.params = {
        keyword: "",
      };
    },
    view(row) {
      this.viewer = {
        dialogVisible: true,
        id: row.id,
        name: row.name,
        mode: "view",
      };
    },
    edit(row) {
      this.viewer = {
        dialogVisible: true,
        id: row.id,
        name: row.name,
        mode: "edit",
      };
    },
    add() {
      this.viewer = {
        dialogVisible: true,
        id: 0,
        name: "添加角色",
        mode: "add",
        checkedKeys: [],
      };
    },
    del(row) {
      this.$confirm("此操作将删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          Http.post("flow/role/delRole", { id: row.id }, (res) => {
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.search();
            } else {
              this.$message.error(res.msg);
              this.search();
            }
          });
        })
        .catch(() => {});
    },
    closeDetail() {
      this.viewer.dialogVisible = false;
      this.search();
    },
    closeUserList() {
      this.userList.dialogVisible = false;
      this.userList.id = 0;
    },
    openUserList(row) {
      this.userList = {
        dialogVisible: true,
        id: row.id,
        name: row.name
      };
    },
  },
};
</script>

<style>
.box-card {
  width: 100%;
  margin-top: 8px;
  margin-left: 8px;
}
.box-table {
  margin-top: 8px;
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Config/Role/RoleList.vue